import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconThumbsUpSvg } from './IconThumbsUpSvg';

export type IconThumbsUpProps = UseIconProps;

export function IconThumbsUp(props: IconThumbsUpProps) {
  const iconProps = useIcon(props);

  return <Box tagName={IconThumbsUpSvg} {...iconProps} />;
}
